import logoSutd from "@assets/events-awards/dta/logo-sutd.jpg";
import logoBT from "@assets/logo-masthead.svg";
import { BlockTitle } from "@blocks/Blocks";

import BusinessTimesSection from "./BusinessTimesSection";
import SUTDSection from "./SUTDSection";

/**
 * Component to render DTA Partners Page
 */
const DTAPartnersPage = (): React.ReactElement => {
  return (
    <div
      data-testid="dta-partners-page-component"
      className="pb-4 font-public-sans"
    >
      <BlockTitle
        text="Partners"
        rootClassName="text-3xl md:text-5xl lg:text-6xl font-medium font-poppins"
      />

      <p className="mb-8 pt-1 text-center">Co-organised By</p>

      <div className="flex flex-col items-center justify-center pb-18 md:flex-row">
        <img
          src={logoBT}
          width={211}
          height={21}
          alt="The Business Times logo"
          className="my-4 mb-8 ml-10 md:my-0 md:ml-0 md:mr-16"
        />

        <img
          src={logoSutd}
          width={141}
          height={54}
          alt="SUTD logo"
          className="my-4 md:ml-16"
        />
      </div>

      <BusinessTimesSection />

      <SUTDSection />
    </div>
  );
};

export default DTAPartnersPage;
